// useRegisterUserDeviceToken.js
import { useCallback } from 'react';
import useApiCall from '../services/api/useApiCall';
import { buildApiConfig } from '../services/api/apiClient';
import { endPointEnums } from '../services/api/endpoints';

// Registers device token for a user using project API conventions
export default function useRegisterParcelDevice() {
  const { makeApiCall } = useApiCall();
  return useCallback(
    async (userId, deviceToken) => {
      const apiConfig = buildApiConfig(endPointEnums.REGISTER_USER_DEVICE, {
        userId,
        deviceToken,
      });
      return makeApiCall(apiConfig, apiConfig.params);
    },
    [makeApiCall]
  );
}
